// 被邀请人
export const INVITEE_NEWUSER_TYPE = 'invitee';
// 助力新人用户
export const HELPER_NEWUSER_TYPE = 'helper';
// 非邀请的用户
export const UNINVITED_USER_TYPE = 'uninvited';

// 注册账号(邀请新人)
export const TASK_REGISTRATION_FOR_INVITEE = 1;
// 登录APP(邀请新人)
export const TASK_LOGIN_FOR_INVITEE = 2;
// 绑定设备(邀请新人)
export const TASK_BIND_FOR_INVITEE = 3;

// 设备在线-电费补贴(邀请新人)
export const TASK_ONLINE_SUBSIDY_FOR_INVITEE = 4;
// 设备在线-现金奖励(邀请新人)
export const TASK_ONLINE_REACH_FOR_INVITEE = 5;
// 首次提现-现金奖励(邀请新人)
export const TASK_WITHDRAW_CASH_FOR_INVITEE = 6;
// 首次提现-加成卡(邀请新人)
export const TASK_WITHDRAW_BONUS_FOR_INVITEE = 7;
// 注册登录账号(自然新人|助力新人用户)
export const TASK_REGISTRATION_FOR_NATURAL = 8;
// 绑定设备-现金奖励(自然新人|助力新人用户)
export const TASK_BIND_CASH_FOR_NATURAL = 9;
// 绑定设备-购机优惠券(自然新人|助力新人用户)
export const TASK_BIND_COUPON_FOR_NATURAL = 10;
// 设备在线(自然新人|助力新人用户)
export const TASK_DEVICE_ONLINE_FOR_NATURAL = 11;
// 绑定x86设备
// export const TASK_BIND_X86_FOR_INVITEE = 12;
// // x86注册登录账号(自然新人|助力新人用户)
// export const TASK_REGISTRATION_X86_14_FOR_NATURAL = 13;
// // x86注册登录账号(自然新人|助力新人用户)
// export const TASK_REGISTRATION_X86_30_FOR_NATURAL = 14;
// x86设备在线(自然新人|助力新人用户)
export const TASK_DEVICE_ONLINE_X86_FOR_NATURAL = 15;

// 首次上机前2台x86可用(自然新人|助力新人用户)
export const TASK_ON_MACHINE_X86_FOR_NATURAL = 24;
// 新增x86带宽1G可得(自然新人|助力新人用户)
export const TASK_NEW_BANDWIDTH_1_X86_FOR_NATURAL = 25;
// 新增x86带宽1G可得(自然新人|助力新人用户)
export const TASK_NEW_BANDWIDTH_10_X86_FOR_NATURAL = 26;
// x86注册登录账号(邀请新人)
// export const TASK_REGISTRATION_X86_14_FOR_INVITEE = 16;
// // x86注册登录账号(邀请新人)
// export const TASK_REGISTRATION_X86_30_FOR_INVITEE = 17;
// x86设备在线(邀请新人)
export const TASK_DEVICE_ONLINE_X86_FOR_INVITEE = 18;
// x86设备绑定福利(邀请新人)
export const TASK_BIND_X86_FOR_INVITEE_2 = 19;
// 绑定设备-现金奖励(邀请新人) （运营弄错了，删除这个20）
// export const TASK_BIND_CASH_FOR_INVITEE = 20;

// 首次上机前2台x86可用(自然新人|助力新人用户)
export const TASK_ON_MACHINE_X86_FOR_INVITEE = 27;
// 新增x86带宽1G可得(自然新人|助力新人用户)
export const TASK_NEW_BANDWIDTH_1_X86_FOR_INVITEE = 28;
// 新增x86带宽1G可得(自然新人|助力新人用户)
export const TASK_NEW_BANDWIDTH_10_X86_FOR_INVITEE = 29;

// 了解网心云（新人助力）
export const TASK_LEARN_FOR_HELPER = 21;
// 测一测我能赚多少钱（新人助力）
export const TASK_TEST_FOR_HELPER = 0;

// 首次提现-云豆奖励(新人助力）
export const TASK_WITHDRAW_CASH_FOR_HELPER = 22;

// 助力新人注册-云豆奖励(新人助力）
export const TASK_REGISTER_NEW_USER_FOR_HELPER = 23;

export const TASK_SUMMARY_FOR_CUSTOMER = {
  [INVITEE_NEWUSER_TYPE]: [
    {
      title: '注册账号',
      type: 'register',
      taskList: [TASK_REGISTRATION_FOR_INVITEE],
    },
    {
      title: '登录APP',
      type: 'login',
      taskList: [TASK_LOGIN_FOR_INVITEE],
    },
    {
      title: '绑定设备',
      type: 'bind',
      taskList: [
        TASK_BIND_FOR_INVITEE,
        // TASK_REGISTRATION_X86_30_FOR_INVITEE,
        // TASK_REGISTRATION_X86_14_FOR_INVITEE,
        TASK_BIND_X86_FOR_INVITEE_2,
        TASK_ON_MACHINE_X86_FOR_INVITEE,
        TASK_NEW_BANDWIDTH_1_X86_FOR_INVITEE,
      ],
    },
    {
      title: '设备在线',
      type: 'online',
      taskList: [
        TASK_ONLINE_REACH_FOR_INVITEE,
        TASK_ONLINE_SUBSIDY_FOR_INVITEE,
        TASK_DEVICE_ONLINE_X86_FOR_INVITEE,
        TASK_NEW_BANDWIDTH_10_X86_FOR_INVITEE,
      ],
    },
    {
      title: '首次提现',
      type: 'withdraw',
      taskList: [TASK_WITHDRAW_CASH_FOR_INVITEE, TASK_WITHDRAW_BONUS_FOR_INVITEE],
    },
  ],
  [UNINVITED_USER_TYPE]: [
    {
      title: '注册登录',
      type: 'login',
      taskList: [TASK_REGISTRATION_FOR_NATURAL],
    },
    {
      title: '绑定设备',
      type: 'bind',
      taskList: [
        TASK_BIND_CASH_FOR_NATURAL,
        TASK_BIND_COUPON_FOR_NATURAL,
        TASK_ON_MACHINE_X86_FOR_NATURAL,
        TASK_NEW_BANDWIDTH_1_X86_FOR_NATURAL,
        // TASK_REGISTRATION_X86_14_FOR_NATURAL,
        // TASK_REGISTRATION_X86_30_FOR_NATURAL,
      ],
    },
    {
      title: '设备在线',
      type: 'online',
      taskList: [
        TASK_DEVICE_ONLINE_FOR_NATURAL,
        TASK_DEVICE_ONLINE_X86_FOR_NATURAL,
        TASK_NEW_BANDWIDTH_10_X86_FOR_NATURAL,
      ],
    },
  ],
  [HELPER_NEWUSER_TYPE]: [
    {
      title: '注册登录',
      type: 'login',
      taskList: [TASK_REGISTRATION_FOR_NATURAL, TASK_REGISTER_NEW_USER_FOR_HELPER],
    },
    {
      title: '了解网心云',
      type: 'learn',
      // taskList: [TASK_LEARN_FOR_HELPER, TASK_TEST_FOR_HELPER],
      taskList: [TASK_TEST_FOR_HELPER],
    },
    {
      title: '绑定设备',
      type: 'bind',
      taskList: [
        TASK_BIND_CASH_FOR_NATURAL,
        TASK_BIND_COUPON_FOR_NATURAL,
        TASK_ON_MACHINE_X86_FOR_NATURAL,
        TASK_NEW_BANDWIDTH_1_X86_FOR_NATURAL,
        // TASK_REGISTRATION_X86_14_FOR_NATURAL,
        // TASK_REGISTRATION_X86_30_FOR_NATURAL,
      ],
    },
    {
      title: '设备在线',
      type: 'online',
      taskList: [
        TASK_DEVICE_ONLINE_FOR_NATURAL,
        TASK_DEVICE_ONLINE_X86_FOR_NATURAL,
        TASK_NEW_BANDWIDTH_10_X86_FOR_NATURAL,
      ],
    },
    {
      title: '首次提现',
      type: 'withdraw',
      taskList: [TASK_WITHDRAW_CASH_FOR_HELPER],
    },
  ],
};

// 任务完成状态-待完成
export const TASK_TO_BE_COMPLETED_STATUS = 0;
// 任务完成状态-已完成
export const TASK_COMPLETED_STATUS = 1;
// 任务完成状态-已过期
export const TASK_EXPIRED_STATUS = 2;

export const TASK_STATUS = {
  [TASK_TO_BE_COMPLETED_STATUS]: '待完成',
  [TASK_COMPLETED_STATUS]: '已完成',
  [TASK_EXPIRED_STATUS]: '已过期',
};

export const TASK_INFO = {
  [TASK_REGISTRATION_FOR_INVITEE]: {
    taskTitle: '注册福利',
    rewardNum: '1',
    rewardUnit: '元',
    rewardTag: '',
    rewardType: '现金奖励',
    taskCondition: '完成注册可得',
    // 任务说明
    taskDetail: '',
    // 是否展示按钮
    withBtn: true,
    // 是否展示任务有效期
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去注册',
      [TASK_COMPLETED_STATUS]: '已完成',
      [TASK_EXPIRED_STATUS]: '已过期',
    },
  },
  [TASK_LOGIN_FOR_INVITEE]: {
    taskTitle: '登录福利',
    rewardNum: '50',
    rewardUnit: '%',
    rewardTag: '',
    rewardType: '14天加成卡',
    taskCondition: '登录APP可得',
    taskDetail: '',
    withBtn: true,
    showTaskEndTime: true,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去登录',
      [TASK_COMPLETED_STATUS]: '已完成',
      [TASK_EXPIRED_STATUS]: '已过期',
    },
  },
  // [TASK_REGISTRATION_X86_14_FOR_INVITEE]: {
  //   taskTitle: '',
  //   rewardNum: '30',
  //   rewardUnit: '%',
  //   rewardTag: '',
  //   rewardType: '30天加成卡',
  //   taskCondition: '上机x86设备可用',
  //   taskDetail: ` <h5>奖励规则</h5>
  //                 <p>1、首次注册登录网心云平台的新用户；</p>
  //                 <p>2、有电脑、服务器、nas、群晖、星际蜗牛、工控机、云主机等x86架构设备均可参与；</p>
  //                 <p>3、加成卡单日单设备加成收益上限200云豆(≈2元)，有效期为14天。</p>`,
  //   withBtn: true,
  //   showTaskEndTime: false,
  //   buttonConfig: {
  //     [TASK_TO_BE_COMPLETED_STATUS]: '立即使用',
  //     [TASK_COMPLETED_STATUS]: '立即使用',
  //     [TASK_EXPIRED_STATUS]: '立即使用',
  //   },
  // },
  // [TASK_REGISTRATION_X86_30_FOR_INVITEE]: {
  //   taskTitle: '',
  //   rewardNum: '1w',
  //   rewardUnit: '云豆',
  //   rewardTag: '最高',
  //   rewardType: '30天加成卡',
  //   taskCondition: '上机x86设备可用',
  //   taskDetail: ` <h5>奖励规则</h5>
  //                 <p>1、首次注册登录网心云平台的新用户；</p>
  //                 <p>2、有电脑、服务器、nas、群晖、星际蜗牛、工控机、云主机等x86架构设备均可参与；</p>
  //                 <p>3、加成卡单日单设备加成收益上限1万云豆(≈100元)，有效期为30天。</p>`,
  //   withBtn: true,
  //   showTaskEndTime: false,
  //   buttonConfig: {
  //     [TASK_TO_BE_COMPLETED_STATUS]: '立即使用',
  //     [TASK_COMPLETED_STATUS]: '立即使用',
  //     [TASK_EXPIRED_STATUS]: '立即使用',
  //   },
  // },

  [TASK_ON_MACHINE_X86_FOR_INVITEE]: {
    taskTitle: '',
    rewardNum: '102',
    rewardUnit: '元',
    rewardTag: '拿满日增',
    rewardType: '收益加成卡',
    taskCondition: '首次上机前2台x86可用',
    taskDetail: ` <h5>奖励规则</h5>
                  <p>【30 天30% 加成卡规则】（推荐智能业务、B 网盘业务使用）</p>
                  <p>1、首次注册登录网心云平台的新用户；</p>
                  <p>2、有电脑、服务器、nas、群晖、星际蜗牛、工控机、云主机等x86架构设备均可参与；</p>
                  <p>3、加成卡单日单设备加成收益上限200云豆(≈2元)，有效期为14天。</p>
                  <p> </p>
                  <p>【30 天 10% 加成卡规则】（推荐其他定向业务使用）</p>
                  <p>1、首次注册登录网心云平台的新用户；</p>
                  <p>2、有电脑、服务器、nas、群晖、星际蜗牛、工控机、云主机等x86架构设备均可参与；</p>
                  <p>3、加成卡单日单设备加成收益上限1万云豆(≈100元)，有效期为30天。</p>`,
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '立即使用',
      [TASK_COMPLETED_STATUS]: '立即使用',
      [TASK_EXPIRED_STATUS]: '立即使用',
    },
  },

  [TASK_NEW_BANDWIDTH_1_X86_FOR_INVITEE]: {
    taskTitle: '',
    rewardNum: '10',
    rewardUnit: '%',
    rewardTag: '',
    rewardType: '限时加机奖',
    taskCondition: '新增x86带宽1G可得',
    taskDetail: ` <h5>奖励规则</h5>
                  <p>活动要求：新增x86带宽达1G</p>
                  <p>活动奖励：限时收益加成10%</p>
                  <p>参与方式：点击【立即报名】查看活动及报名。</p>`,
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '立即报名',
      [TASK_COMPLETED_STATUS]: '立即报名',
      [TASK_EXPIRED_STATUS]: '立即报名',
    },
  },

  [TASK_BIND_FOR_INVITEE]: {
    taskTitle: '绑定福利',
    rewardNum: '5',
    rewardUnit: '元',
    rewardTag: '最高',
    rewardType: '奖励',
    taskCondition: '绑定首台有效设备可得',
    taskDetail: ` <h5>奖励规则</h5>
                    <p>
                      <em>绑定首台有效设备且在线得奖励</em>
                    </p>
                    <p>OEC系列/OEA系列：5元；</p>
                    <p>赚钱宝3代/容器魔方/三方盒子/纳思小星/赚钱宝电脑版/手机宝/电脑宝：1元。</p>
                    <p>x86（智能业务）：1元+30天30%收益加成</p>
                    <p><span>*首绑手机宝奖励实时发放；首绑赚钱宝3代/容器魔方将根据在线情况，绑定后第4日发奖；首绑其他设备奖励于次日发放。</span></p>
                    <p><span>*若绑定当天解绑，奖励将无法获得。完成绑定后，任务状态次日更新（首绑赚钱宝3代/容器魔方将在绑定后第4日更新）</span></p>
                    <h5>什么是有效设备？</h5>
                    <p>包含OEC系列/赚钱宝3代/三方盒子/容器魔方/nas小星/赚钱宝电脑版/手机宝/电脑宝/OEA系列/x86智能业务（自绑定之日起，前30天内未在线过）</p>`,
    withBtn: true,
    showTaskEndTime: true,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去绑定',
      [TASK_COMPLETED_STATUS]: '已完成',
      [TASK_EXPIRED_STATUS]: '已过期',
    },
  },
  // [TASK_BIND_X86_FOR_INVITEE]: {
  //   taskTitle: '',
  //   rewardNum: '30',
  //   rewardUnit: '天',
  //   rewardTag: '',
  //   rewardType: '30%加成',
  //   taskCondition: '绑定x86即可使用',
  //   taskDetail: ` <h5>奖励规则</h5>
  //                   <p>1、首次注册登录网心云平台的新用户；</p>
  //                   <p>2、有电脑、服务器、nas、群晖、星际蜗牛、工控机等x86架构设备均可参与；</p>
  //                   <p>3、加成卡有效期为14天。</p>
  //                   <h5>使用方式</h5>
  //                   <p>前往【我的】-【权益】选择加成卡使用</p>`,
  //   withBtn: true,
  //   showTaskEndTime: false,
  //   buttonConfig: {
  //     [TASK_TO_BE_COMPLETED_STATUS]: '了解x86',
  //     [TASK_COMPLETED_STATUS]: '了解x86',
  //     [TASK_EXPIRED_STATUS]: '了解x86',
  //   },
  // },
  [TASK_BIND_X86_FOR_INVITEE_2]: {
    taskTitle: '',
    rewardNum: '30',
    rewardUnit: '天',
    rewardTag: '',
    rewardType: '10%加成',
    taskCondition: '绑定x86达标设备可得',
    taskDetail: ` <h5>奖励规则</h5>
                    <p>1、单账号在线智能/网盘业务的达标设备净增≥1台，则可获得奖励资格；</p>
                    <p>2、达标设备定义：【每日贡献收益>2元的设备】且【每日晚高峰（18-24点）在线率达到100%】且【每日12点-24点在线时长达到11.5小时】；</p>
                    <p>3、获得奖励资格后，根据账号内绑定时间先后顺序取 [固定达标设备] 为 [奖励设备] ，可享连续30日收益*10%，净增X台则前X台为 [奖励设备]，最多3台;</p>
                    <p>4、若设备在线要求或贡献收益不达标，则当天奖励失效，后续继续上线，则奖励恢复发放，发放天数为首次达标（含）后的连续30日；</p>
                    <p>5、相同实名为同一个用户，如有换绑、重装等刷奖励行为，则奖励资格取消。</p>`,
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '了解x86',
      [TASK_COMPLETED_STATUS]: '了解x86',
      [TASK_EXPIRED_STATUS]: '了解x86',
    },
  },
  [TASK_ONLINE_SUBSIDY_FOR_INVITEE]: {
    taskTitle: '',
    rewardNum: '3.5',
    rewardUnit: '元',
    rewardTag: '最高',
    rewardType: '电费补贴',
    taskCondition: '首绑设备在线每日得0.5（最高），共得7天',
    taskDetail: ` <h5>奖励规则</h5>
                  <p>
                    <em>绑定首台设备后，次日起连续7天保持全天24小时在线，每天得电费补贴。</em>
                  </p>
                  <p><span>*奖励于次日发放，若在绑定当日解绑设备，奖励将无法获得。完成绑定后，任务状态次日更新。</span></p>
                  <h5>详细说明</h5>
                  <p>1、自2025年1月8日0点起，新用户绑定的首台设备类型为容器魔方或纳思小星，满足在线后，每天可得0.5元电费补贴，一共得7天;</p>
                  <p>2、新用户首台设备绑定的类型为容器魔方或纳思小星以外的，满足在线后，每天可得0.2元电费补贴。</p>
                `,
    withBtn: false,
    showTaskEndTime: false,
    buttonConfig: {
      // [TASK_TO_BE_COMPLETED_STATUS]: '暂未获得',
      // [TASK_COMPLETED_STATUS]: '已完成',
      [TASK_EXPIRED_STATUS]: '已过期',
    },
  },
  [TASK_ONLINE_REACH_FOR_INVITEE]: {
    taskTitle: '在线福利',
    rewardNum: '5',
    rewardUnit: '元',
    rewardTag: '最高',
    rewardType: '奖励',
    taskCondition: '有效设备在线达标可得',
    taskDetail: ` <h5>奖励规则</h5>
                    <p>
                    <em>您名下有≥1台有效设备满足累计7天在线达标，即可获得以下奖励：</em>
                    </p>
                    <p>OEC系列/赚钱宝3代/OEA系列/ x86（智能业务）：5元；</p>
                    <p>容器魔方/三方盒子/纳思小星/赚钱宝电脑版/手机宝/电脑宝：1元</p>
                    <p><span>*该奖励将于次日发放至【网心云app-我的-钱包】</span></p>
                    <p><span>*智能业务：绑定x86设备并成功激活，系统将会自动分配智能业务，若您不报名定向业务，即为在线智能业务。</span></p>
                    <h5>什么是在线达标？</h5>
                    <p>设备每天在线≥20个小时，且晚高峰18点～24点贡献带宽≥6M</p>`,
    withBtn: true,
    showTaskEndTime: true,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '看进度',
      [TASK_COMPLETED_STATUS]: '已完成',
      [TASK_EXPIRED_STATUS]: '已过期',
    },
  },
  [TASK_DEVICE_ONLINE_X86_FOR_INVITEE]: {
    taskTitle: '',
    rewardNum: '3.5',
    rewardUnit: '元',
    rewardTag: '',
    rewardType: '新人补贴',
    taskCondition: '首绑x86设备在线前7日可得',
    taskDetail: ` <p><em>自4月8日起，新用户上线x86的首台新设备，符合在线要求，则次日起连续7天每天可以获得0.5元新人补贴；</em></p>
                  <h5>在线要求</h5>
                  <p>【每日晚高峰（18-24点）在线率达到100%】且【每日12点-24点在线时长达到11.5小时】</p>
                  <h5>详细说明</h5>
                  <p>绑定首台设备必须为新设备，如解除绑定、换绑、在线不达标，则奖励失效。</p>
                  `,
    withBtn: false,
    showTaskEndTime: false,
    buttonConfig: {
      // [TASK_TO_BE_COMPLETED_STATUS]: '了解x86',
      // [TASK_COMPLETED_STATUS]: '了解x86',
      // [TASK_EXPIRED_STATUS]: '了解x86',
    },
  },
  // 新增x86带宽10G可得
  [TASK_NEW_BANDWIDTH_10_X86_FOR_INVITEE]: {
    taskTitle: '',
    rewardNum: '',
    rewardUnit: '王牌业务',
    rewardTag: '',
    rewardType: '加1v1服务',
    taskCondition: '新增x86带宽10G可得',
    taskDetail: ` <h5>奖励规则</h5>
                  <p>新增x86带宽达10G，可享受进阶服务：</p>
                  <p>1、获得王牌业务上机资格，高价格高跑量；</p>
                  <p>2、可获得1v1技术服务支持，收益和服务双升级，具体请联系商务获取；</p>
                  <p>*可在x86上机指南中扫码添加或社群联系任一网心云运营咨询。</p>
                 `,
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去了解',
      [TASK_COMPLETED_STATUS]: '去了解',
      [TASK_EXPIRED_STATUS]: '去了解',
    },
  },
  [TASK_WITHDRAW_CASH_FOR_INVITEE]: {
    taskTitle: '提现福利',
    rewardNum: '0.5',
    rewardUnit: '元',
    rewardTag: '',
    rewardType: '奖励',
    taskCondition: '首次成功提现可得',
    taskDetail: '',
    withBtn: true,
    showTaskEndTime: true,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去提现',
      [TASK_COMPLETED_STATUS]: '已完成',
      [TASK_EXPIRED_STATUS]: '已过期',
    },
  },
  [TASK_WITHDRAW_BONUS_FOR_INVITEE]: {
    taskTitle: '',
    rewardNum: '15',
    rewardUnit: '%',
    rewardTag: '',
    rewardType: '7天加成卡',
    taskCondition: '首次成功提现可得',
    taskDetail: '',
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去提现',
      [TASK_COMPLETED_STATUS]: '已完成',
      [TASK_EXPIRED_STATUS]: '已过期',
    },
  },
  [TASK_REGISTRATION_FOR_NATURAL]: {
    taskTitle: '注册登录福利',
    rewardNum: '50',
    rewardUnit: '%',
    rewardTag: '',
    rewardType: '14天加成卡',
    taskCondition: '注册、登录可得，推荐绑定电脑宝使用',
    taskDetail: '',
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去使用',
      [TASK_COMPLETED_STATUS]: '已完成',
      [TASK_EXPIRED_STATUS]: '已过期',
    },
  },
  // [TASK_REGISTRATION_X86_14_FOR_NATURAL]: {
  //   taskTitle: '',
  //   rewardNum: '30',
  //   rewardUnit: '%',
  //   rewardTag: '',
  //   rewardType: '30天加成卡',
  //   taskCondition: '上机x86设备可用',
  //   taskDetail: ` <h5>奖励规则</h5>
  //                 <p>1、首次注册登录网心云平台的新用户；</p>
  //                 <p>2、有电脑、服务器、nas、群晖、星际蜗牛、工控机、云主机等x86架构设备均可参与；</p>
  //                 <p>3、加成卡单日单设备加成收益上限200云豆(≈2元)，有效期为14天。</p>`,
  //   withBtn: true,
  //   showTaskEndTime: false,
  //   buttonConfig: {
  //     [TASK_TO_BE_COMPLETED_STATUS]: '立即使用',
  //     [TASK_COMPLETED_STATUS]: '立即使用',
  //     [TASK_EXPIRED_STATUS]: '立即使用',
  //   },
  // },
  // [TASK_REGISTRATION_X86_30_FOR_NATURAL]: {
  //   taskTitle: '',
  //   rewardNum: '1w',
  //   rewardUnit: '云豆',
  //   rewardTag: '最高',
  //   rewardType: '30天加成卡',
  //   taskCondition: '上机x86设备可用',
  //   taskDetail: ` <h5>奖励规则</h5>
  //                 <p>1、首次注册登录网心云平台的新用户；</p>
  //                 <p>2、有电脑、服务器、nas、群晖、星际蜗牛、工控机、云主机等x86架构设备均可参与；</p>
  //                 <p>3、加成卡单日单设备加成收益上限1万云豆(≈100元)，有效期为30天。</p>`,
  //   withBtn: true,
  //   showTaskEndTime: false,
  //   buttonConfig: {
  //     [TASK_TO_BE_COMPLETED_STATUS]: '立即使用',
  //     [TASK_COMPLETED_STATUS]: '立即使用',
  //     [TASK_EXPIRED_STATUS]: '立即使用',
  //   },
  // },
  [TASK_ON_MACHINE_X86_FOR_NATURAL]: {
    taskTitle: '',
    rewardNum: '102',
    rewardUnit: '元',
    rewardTag: '拿满日增',
    rewardType: '收益加成卡',
    taskCondition: '首次上机前2台x86可用',
    taskDetail: ` <h5>奖励规则</h5>
                  <p>【30 天30% 加成卡规则】（推荐智能业务、B 网盘业务使用）</p>
                  <p>1、首次注册登录网心云平台的新用户；</p>
                  <p>2、有电脑、服务器、nas、群晖、星际蜗牛、工控机、云主机等x86架构设备均可参与；</p>
                  <p>3、加成卡单日单设备加成收益上限200云豆(≈2元)，有效期为14天。</p>
                  <p></p>
                  <p>【30 天 10% 加成卡规则】（推荐其他定向业务使用）</p>
                  <p>1、首次注册登录网心云平台的新用户；</p>
                  <p>2、有电脑、服务器、nas、群晖、星际蜗牛、工控机、云主机等x86架构设备均可参与；</p>
                  <p>3、加成卡单日单设备加成收益上限1万云豆(≈100元)，有效期为30天。</p>`,
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '立即使用',
      [TASK_COMPLETED_STATUS]: '立即使用',
      [TASK_EXPIRED_STATUS]: '立即使用',
    },
  },

  [TASK_NEW_BANDWIDTH_1_X86_FOR_NATURAL]: {
    taskTitle: '',
    rewardNum: '10',
    rewardUnit: '%',
    rewardTag: '',
    rewardType: '限时加机奖',
    taskCondition: '新增x86带宽1G可得',
    taskDetail: ` <h5>奖励规则</h5>
                  <p>活动要求：新增x86带宽达1G</p>
                  <p>活动奖励：限时收益加成10%</p>
                  <p>参与方式：点击【立即报名】查看活动及报名。</p>`,
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '立即报名',
      [TASK_COMPLETED_STATUS]: '立即报名',
      [TASK_EXPIRED_STATUS]: '立即报名',
    },
  },

  [TASK_BIND_CASH_FOR_NATURAL]: {
    taskTitle: '绑定福利',
    rewardNum: '1',
    rewardUnit: '元',
    rewardTag: '',
    rewardType: '现金奖励',
    taskCondition: '绑定首台手机宝实时发放',
    taskDetail: ` <h5>奖励规则</h5>
                  <p><em>绑定首台手机宝设备可实时获得1元奖励；</em></p>
                  <p>绑定【赚钱宝3代/OE系列】次日可得200云豆，绑定其他类型设备次日得100云豆。</p>
                  <p><span> *若绑定当天解绑设备，奖励将无法获得。完成绑定后，任务状态次日更新。</span></p>`,
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去绑定',
      [TASK_COMPLETED_STATUS]: '已完成',
      [TASK_EXPIRED_STATUS]: '已过期',
    },
  },
  [TASK_BIND_COUPON_FOR_NATURAL]: {
    taskTitle: '',
    rewardNum: '10',
    rewardUnit: '元',
    rewardTag: '',
    rewardType: '通用抵扣券',
    taskCondition: '官方OE设备可用',
    taskDetail: '',
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去购买',
      [TASK_COMPLETED_STATUS]: '去购买',
      [TASK_EXPIRED_STATUS]: '已过期',
    },
  },
  [TASK_DEVICE_ONLINE_FOR_NATURAL]: {
    taskTitle: '在线福利',
    rewardNum: '3.5',
    rewardUnit: '元',
    rewardTag: '最高',
    rewardType: '电费补贴',
    taskCondition: '首绑设备在线每日得0.5（最高），共得7天',
    taskDetail: ` <h5>奖励规则</h5>
                  <p><em>绑定首台设备后，次日起连续7天保持全天24小时在线，每天得电费补贴。</em></p>
                  <p><span>*奖励于次日发放，若在绑定当日解绑设备，奖励将无法获得。完成绑定后，任务状态次日更新。</span></p>
                  <h5>详细说明</h5>
                  <p>1、自2025年1月8日0点起，新用户绑定的首台设备类型为容器魔方或纳思小星，满足在线后，每天可得0.5元电费补贴，一共得7天;</p>
                  <p>2、新用户首台设备绑定的类型为容器魔方或纳思小星以外的，满足在线后，每天可得0.2元电费补贴；</p>
                  <p>3、以上补贴以云豆形式进行发放。</p>
                `,
    withBtn: false,
    showTaskEndTime: false,
    buttonConfig: {
      // [TASK_TO_BE_COMPLETED_STATUS]: '暂未获得',
      // [TASK_COMPLETED_STATUS]: '已完成',
      [TASK_EXPIRED_STATUS]: '已过期',
    },
  },
  [TASK_DEVICE_ONLINE_X86_FOR_NATURAL]: {
    taskTitle: '',
    rewardNum: '3.5',
    rewardUnit: '元',
    rewardTag: '',
    rewardType: '新人补贴',
    taskCondition: '首绑x86设备在线前7日可得',
    taskDetail: ` <p><em>自4月8日起，新用户上线x86的首台新设备，符合在线要求，则次日起连续7天每天可以获得0.5元新人补贴；</em></p>
                  <h5>在线要求</h5>
                  <p>【每日晚高峰（18-24点）在线率达到100%】且【每日12点-24点在线时长达到11.5小时】</p>
                  <h5>详细说明</h5>
                  <p>绑定首台设备必须为新设备，如解除绑定、换绑、在线不达标，则奖励失效。</p>
                  `,
    withBtn: false,
    showTaskEndTime: false,
    buttonConfig: {
      // [TASK_TO_BE_COMPLETED_STATUS]: '了解x86',
      // [TASK_COMPLETED_STATUS]: '了解x86',
      // [TASK_EXPIRED_STATUS]: '了解x86',
    },
  },
  // 新增x86带宽10G可得
  [TASK_NEW_BANDWIDTH_10_X86_FOR_NATURAL]: {
    taskTitle: '',
    rewardNum: '',
    rewardUnit: '王牌业务',
    rewardTag: '',
    rewardType: '加1v1服务',
    taskCondition: '新增x86带宽10G可得',
    taskDetail: ` <h5>奖励规则</h5>
                  <p>新增x86带宽达10G，可享受进阶服务：</p>
                  <p>1、获得王牌业务上机资格，高价格高跑量；</p>
                  <p>2、可获得1v1技术服务支持，收益和服务双升级，具体请联系商务获取；</p>
                  <p>*可在x86上机指南中扫码添加或社群联系任一网心云运营咨询。</p>
                  <p></p>
                 `,
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去了解',
      [TASK_COMPLETED_STATUS]: '去了解',
      [TASK_EXPIRED_STATUS]: '去了解',
    },
  },

  [TASK_LEARN_FOR_HELPER]: {
    taskTitle: '了解网心云',
    rewardNum: '50',
    rewardUnit: '',
    rewardTag: '等值0.5元',
    rewardType: '云豆奖励',
    taskCondition: '浏览网心云介绍15秒',
    taskDetail: `<p><em>通过助力链接注册的网心云新用户，首次完成浏览网心云介绍页15秒，即可获得50云豆（可兑换0.5元）；</em></p>`,
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去了解',
      [TASK_COMPLETED_STATUS]: '已完成',
    },
  },

  [TASK_TEST_FOR_HELPER]: {
    taskTitle: '测网速',
    rewardNum: '测',
    rewardUnit: '',
    rewardTag: '',
    rewardType: '',
    taskCondition: '测一测我能赚多少钱',
    taskDetail: '',
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去看看',
      [TASK_COMPLETED_STATUS]: '去看看',
      [TASK_EXPIRED_STATUS]: '去看看',
    },
  },
  [TASK_WITHDRAW_CASH_FOR_HELPER]: {
    taskTitle: '首次提现',
    rewardNum: '50',
    rewardUnit: '',
    rewardTag: '等值0.5元',
    rewardType: '云豆奖励',
    taskCondition: '首次完成提现',
    taskDetail: `<p><em>在您注册之日起60天内，完成【首次提现】后，可得50云豆（可兑换0.5元）；</em></p>`,
    withBtn: true,
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_TO_BE_COMPLETED_STATUS]: '去提现',
      [TASK_COMPLETED_STATUS]: '已完成',
      [TASK_EXPIRED_STATUS]: '已过期',
    },
  },
  [TASK_REGISTER_NEW_USER_FOR_HELPER]: {
    taskTitle: '',
    rewardNum: '100',
    rewardUnit: '',
    rewardTag: '等值1元',
    rewardType: '云豆奖励',
    taskCondition: '完成注册可得',
    // 任务说明
    taskDetail: '',
    // 是否展示按钮
    withBtn: true,
    // 是否展示任务有效期
    showTaskEndTime: false,
    buttonConfig: {
      [TASK_COMPLETED_STATUS]: '已完成',
    },
  },
};

export const PAGE_TITLE_MAP = {
  [UNINVITED_USER_TYPE]: '新人福利',
  [INVITEE_NEWUSER_TYPE]: '新人礼包',
  [HELPER_NEWUSER_TYPE]: '助力新人',
};

// invitationType对应的用户类型映射
export const INVIATION_USER_TYPE_MAP = {
  0: UNINVITED_USER_TYPE,
  1: INVITEE_NEWUSER_TYPE,
  2: HELPER_NEWUSER_TYPE,
};
